import { makeAutoObservable } from 'mobx';

class BaseStore {
    isLoading = false;

    constructor() {
        makeAutoObservable(this);
    }

    showLoading = () => {
        this.isLoading = true;
    };

    hideLoading = () => {
        this.isLoading = false;
    };
}

export const baseStore = new BaseStore();